<template>
  <vx-card title="Contenido">
    <p>Aquí se puede modificar la información más relevante.</p>

    <div v-if="initProgress" style="margin-top: 1rem; width: 100%">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <div class="mt-5">
      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.email= trimString(content.email)"
                    v-validate="'required'"
                    name="email" class="w-full"
                    label="Email"
                    v-model="content.email"/>
          <span class="text-danger text-sm"
                v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>

      <!--Payment methods (Without Invoice)-->
      <div>
        <vs-textarea
            @blur="content.accounts= trimString(content.accounts)"
            v-validate="'required'"
            name="accounts"
            class="w-full"
            label="Cuentas sin factura*"
            rows="12"
            v-model="content.accounts"/>
        <span class="text-danger text-sm"
              v-show="errors.has('accounts')">{{ errors.first('accounts') }}</span>
      </div>
      <!--End-->

      <!--Payment methods (Invoice)-->
      <div>
        <vs-textarea
            @blur="content.invoiceAccounts= trimString(content.invoiceAccounts)"
            v-validate="'required'"
            name="invoiceAccounts"
            class="w-full"
            label="Cuentas para factura*"
            rows="12"
            v-model="content.invoiceAccounts"/>
        <span class="text-danger text-sm"
              v-show="errors.has('invoiceAccounts')">{{ errors.first('invoiceAccounts') }}</span>
      </div>
      <!--End-->

      <div class="flex mt-6 flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="progress">Guardar</vs-button>
        <div v-if="progress" style="margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import trimString from '../mixins/trimString'

import { auth, db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  name: 'Content',
  mixins: [
    trimString
  ],
  data () {
    return {
      content: {},
      progress: false,
      initProgress: false
    }
  },
  /**
   * Get data on firestore
   * @returns {Promise<void>}
   */
  async created () {
    try {
      this.initProgress = true
      await db.collection('content').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.content = {
            id: doc.id,
            ...doc.data()
          }
        })
        this.initProgress = false
      })
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any()
    }
  },
  methods: {
    /**
     *  Save data in firestore
     */
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          // Content
          let contentRef = db.collection('content').doc(this.content.id)

          //Clone to remove the id
          let cloneContent = Object.assign({}, this.content)
          delete cloneContent.id

          await contentRef.update({
            ...cloneContent,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          })

          this.progress = false
          this.$vs.notify({
            color: 'success',
            title: 'Contenido',
            text: 'Contenido modificado correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    }
  }
}
</script>
